// @flow
import React from 'react'
import { Header, Image, Visibility } from 'semantic-ui-react'
import { Link } from '../../../../../../../shared/components/Link'
import { mercury, platinum, prussian, tomato } from 'constants/inlineStyles'
import { SchoolIcon } from 'components/icons'

let styles = {}

type OwnProps = {
  header: string,
  imageUrl: string,
  pageCount: number,
  ocrText: string,
  senderEmail: string,
  category: string,
  linkTo: string,
  flyerTitle: string,
  handleMetricClick: ({ flyerId: string, resource: string }) => () => boolean,
  flyerId: string,
  isGroupVisible: boolean,
  setGroupVisible: () => void
}

const FlyerCard = ({
  header,
  imageUrl,
  pageCount,
  ocrText,
  senderEmail,
  category,
  linkTo,
  flyerTitle,
  handleMetricClick,
  flyerId,
  isGroupVisible,
  setGroupVisible
}: OwnProps): React$Element<*> => {
  const sellerIsSchool = category === 'School'

  return (
    <Visibility onOnScreen={setGroupVisible} fireOnMount data-testid="flyer">
      <Link
        to={linkTo}
        onClick={handleMetricClick({ flyerId, resource: 'viewflyer' })}
        data-testid="flyer-link"
      >
        <div style={styles.flyerWrapper}>
          <div style={styles.headerWrapper}>
            <Header as="h6" style={styles.flyerHeader} content={header} data-testid="flyer-title" />
          </div>
          <div
            style={
              pageCount > 1
                ? styles.flyerImageWrapper.multiPage
                : styles.flyerImageWrapper.singlePage
            }
          >
            {isGroupVisible && (
              <Image
                src={imageUrl}
                style={styles.flyerImage}
                alt={`Image of a flyer titled ${flyerTitle}`}
                aria-describedby={`flyer-Description-${flyerId}`}
                data-testid="flyer-thumbnail"
              />
            )}
            <span
              id={`flyer-Description-${flyerId}`}
              style={styles.flyerDescription}
              data-testid="flyer-description"
            >
              Text Found On Flyer -
              {ocrText || 'No Text Available'} Need more information on this
              flyer? You can email the person who submitted the flyer at{' '}
              {senderEmail} to learn more.
            </span>
          </div>
          <div style={styles.metaWrapper}>
            {sellerIsSchool && <SchoolIcon style={styles.schoolIcon} />}
            <span style={styles.viewLabel}>View</span>
            {pageCount > 1 && (
              <span style={styles.pageNumbers} data-testid="flyer-page-count">1 of {pageCount}</span>
            )}
          </div>
        </div>
      </Link>
    </Visibility>
  )
}

styles = {
  headerWrapper: {
    height: 'auto',
    marginBottom: '5px',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    lineHeight: '1.12',
    color: prussian,
    overflow: 'hidden'
  },
  flyerWrapper: {
    fontSize: '.875rem',
    width: '13.75em'
  },
  flyerHeader: {
    fontSize: '1rem',
    lineHeight: '1.12',
    fontWeight: 'normal',
    overflow: 'hidden'
  },
  flyerImageWrapper: {
    singlePage: {
      height: '17.63em',
      width: '13.75em',
      backgroundColor: mercury,
      margin: '0',
      padding: '.3125em',
      outline: `.0625em solid ${platinum}`
    },
    multiPage: {
      height: '17.05em',
      width: '13.25em',
      backgroundColor: mercury,
      marginBottom: '.6825em',
      marginRight: '.5625em',
      padding: '.3125em',
      outline: `.0625em solid ${platinum}`,
      boxShadow: `
        .0625em .0625em ${platinum},
        .25em .3125em ${mercury},
        .3125em .375em ${platinum},
        .5em .625em ${mercury},
        .5625em .6825em ${platinum}
      `
    }
  },
  flyerImage: {
    maxWidth: '100%',
    maxHeight: '100%',
    margin: '0 auto'
  },
  // for screen reader compliance
  flyerDescription: {
    position: 'absolute',
    left: '-10000px',
    top: 'auto',
    width: '1px',
    height: '1px',
    overflow: 'hidden'
  },
  metaWrapper: {
    textAlign: 'center',
    position: 'relative',
    lineHeight: '1.12',
    paddingTop: '5px'
  },
  viewLabel: {
    fontSize: '1rem',
    color: tomato,
    fontWeight: 'bold'
  },
  pageNumbers: {
    color: prussian,
    fontSize: '1rem',
    fontWeight: 'bold',
    position: 'absolute',
    textAlign: 'right',
    right: 0
  },
  schoolIcon: {
    position: 'absolute',
    left: 0,
    top: 0
  }
}

export default FlyerCard



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerGrid/components/FlyerGridBody/components/FlyerCard.js